import React from 'react';
import PropTypes from 'prop-types';
import './analytics-view-message.scss';

function AnalyticsViewMessage({ message }) {
    return (
        <div className='analytics-view-message'>
            {message}
        </div>
    );
}

AnalyticsViewMessage.propTypes = {
    message: PropTypes.string.isRequired
};

export default AnalyticsViewMessage;
